import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip, Typography } from '@routific/hive/v5';
import type { V5ChipColor } from '@routific/hive/v5';
import { OrderStatus } from '../../../../store/mst/models';
import LocationExceptionWarning from '../../../shared/LocationExceptionWarning';
import { InlineRow } from './styles';

interface TimelineCardHeaderProps {
  status: OrderStatus;
  date?: string;
  hasLocationException?: boolean;
}

const statusToChipColor: Partial<Record<OrderStatus, V5ChipColor>> = {
  [OrderStatus.SCHEDULED]: 'neutral',
  [OrderStatus.DELIVERED]: 'success',
  [OrderStatus.MISSED]: 'warning',
};

const TimelineCardHeader: React.FC<TimelineCardHeaderProps> = ({ status, date, hasLocationException }) => {
  const { t } = useTranslation('common');
  const chipColor = statusToChipColor[status];
  const statusLabel = t(`orderDetails.status.${status}`);
  const hasDate = date != null && date !== '';

  return (
    <InlineRow style={{ width: '100%' }}>
      <Chip color={chipColor} size="sm">
        {statusLabel}
      </Chip>
      {hasLocationException && <LocationExceptionWarning variant="icon" />}
      {hasDate && (
        <Typography variant="body" style={{ marginLeft: 'auto' }}>
          {date}
        </Typography>
      )}
    </InlineRow>
  );
};

export default TimelineCardHeader;
